export const FOTO_REFERENTE_EVENTO = 1;
export const FOTO_REFERENTE_REPARO = 2;
export const FOTO_REFERENTE_TERCEIROS = 3;
export const FOTO_REFERENTE_PATRIMONIOS = 4;
export const FOTO_REFERENTE_CROQUI = 5;
export const FOTO_REFERENTE_IMAGE_CROQUI = 6;
export const LIST_CATEGORIAS_CNH = [
  { label: 'A' },
  { label: 'A1' },
  { label: 'B' },
  { label: 'B1' },
  { label: 'BE' },
  { label: 'C' },
  { label: 'C1' },
  { label: 'C1E' },
  { label: 'CE' },
  { label: 'D' },
  { label: 'D1' },
  { label: 'D1E' },
  { label: 'DE' },
  { label: 'E' },
  { label: 'Não possui' },
];

export const TIPO_ENVOLVIDO = {
  TERCEIRO: 'T',
  PATRIMONIO: 'P',
};
